import { FormatInkHighlighter } from '@interhyp/platform-icons';
import React, { useCallback, useState } from 'react';
import { TooltipToolbarItem } from "./TooltipToolbarItem.js";
import { ColorPalette } from "../../colorPalette/ColorPalette.js";
import { getDefaultColors } from "../defaults/getDefaultColors.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function HighlightColorToolbarItem({
  colors,
  active,
  action,
  disabled,
  title = 'Texthintergrundfarbe'
}) {
  const [open, setOpen] = useState(false);
  const handleClick = useCallback(() => {
    if (open) {
      return;
    }
    setOpen(true);
  }, [open]);
  const handleColorSelect = useCallback(color => {
    setOpen(false);
    action?.(color);
  }, [action]);
  return /*#__PURE__*/_jsx("div", {
    style: {
      '--icon-accent-color': active ?? 'transparent'
    },
    children: /*#__PURE__*/_jsx(TooltipToolbarItem, {
      open: open,
      action: handleClick,
      on: false,
      icon: FormatInkHighlighter,
      onClose: () => setOpen(false),
      disabled: disabled,
      title: title,
      children: /*#__PURE__*/_jsx("div", {
        children: open && /*#__PURE__*/_jsx(ColorPalette, {
          active: active,
          onColorSelect: handleColorSelect,
          colors: colors ?? getDefaultColors('TRANSPARENT')
        })
      })
    }, "text-color")
  });
}